import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {ServicesViewsStateType} from "../../types/services-views-state.type";


// DEPRECATED - TO DELETE
export class DeliveriesMapViewTableCtrl implements IController {
  infiniteScroll: any;
  selectedIds: any;
  sortType: any;
  columns: any;
  onSortTypeChange: Function;
  selectedIdsChanged: Function;
  onAction: Function;

  private selectedKeys: any;
  private expandedId: any;
  private asceDescIconsMap: any;

  /* @ngInject */
  constructor(private commonsConstants, private deliveriesConstants) {
  }

  $onInit() {
    this.selectedKeys = {};
    this.expandedId = undefined;
    this.asceDescIconsMap = this.commonsConstants.sortIconsMap;

    this._setColumns(this.columns);

    this.selectedKeys = {};
    _.forEach(this.selectedIds, (selectedId) => {
      this.selectedKeys[selectedId] = true;
    });
  }

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.$onInit();
    }
    if (changes.columns && !changes.columns.isFirstChange()) {
      this._setColumns(this.columns);
    }
  };

  // ******************************
  //        Public methods
  // ******************************

  toggleDelivery(deliveryId) {
    this.selectedKeys[deliveryId] = !this.selectedKeys[deliveryId];
    var selectedIds = _.map(this.selectedKeys, (value, key) => {
      if (value) return key;
    });
    this.selectedIdsChanged({selectedIds: _.compact(selectedIds)});
  }

  onExpand(serviceId) {
    this.expandedId = _.isEqual(this.expandedId, serviceId) ?
      undefined : serviceId;
  }

  // ******************************
  //        Private methods
  // ******************************

  private _setColumns(columns) {
    this.columns = columns || this.commonsConstants.viewsTableColumns[ServicesViewsStateType.DELIVERIES_MAP_STATE];
  }


}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesMapViewTable', {
    bindings: {
      infiniteScroll: '<',
      selectedIds: '<',
      sortType: '<?',
      columns: '<?',
      onSortTypeChange: '&',
      selectedIdsChanged: '&',
      onAction: '&'
    },
    template: require('./deliveries-map-view-table.html').default,
    controller: DeliveriesMapViewTableCtrl
  });
